module.exports = __webpack_public_path__ + "img/axelar_logo.3ffdbe2b.svg";